/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Update upsell title based on active slide
  function updateUpsellTitle() {
    const upsellHolder = document.querySelector('[data-upsell-products]');
    if (!upsellHolder) return;

    const titleElement = upsellHolder.querySelector('[data-upsell-title]');
    if (!titleElement) return;

    // Find the active slide
    const activeSlide = upsellHolder.querySelector('.is-selected[data-slide-title]') || 
                        upsellHolder.querySelector('[data-slide-title]');
    
    if (activeSlide) {
      const title = activeSlide.getAttribute('data-slide-title') || '';
      titleElement.textContent = title;
    }
  }

  // Re-initialize sliders in upsell products after cart update
  function reinitializeUpsellSliders() {
    const upsellHolder = document.querySelector('[data-upsell-products]');
    if (upsellHolder) {
      const sliders = upsellHolder.querySelectorAll('slider-component');
      sliders.forEach(function(slider) {
        // Destroy existing Flickity instance if present
        if (slider.flkty) {
          slider.flkty.destroy();
          slider.flkty = null;
        }
        
        // Dispatch the theme's slider init event
        slider.dispatchEvent(new CustomEvent('theme:slider:init', { bubbles: true }));

        // Setup slide change listener for title updates
        setTimeout(function() {
          if (slider.flkty) {
            slider.flkty.on('change', updateUpsellTitle);
          }
          // Update title initially
          updateUpsellTitle();
        }, 100);
      });

      // Also update title for non-slider upsells
      updateUpsellTitle();
    }
  }

  // Listen for cart change events to reinitialize sliders
  document.addEventListener('theme:cart:change', function() {
    setTimeout(reinitializeUpsellSliders, 300);
    setTimeout(updateUpsellTitle, 500);
  });

  // Also reinitialize when cart drawer opens
  document.addEventListener('theme:cart-drawer:open', function() {
    setTimeout(reinitializeUpsellSliders, 300);
    setTimeout(updateUpsellTitle, 500);
  });

  // Update variant hero text when variant changes
  function getVariantHeroMap() {
    const script = document.querySelector('[data-variant-hero-map]');
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  function getSelectedVariantId() {
    const checkedInput = document.querySelector('variant-selects input[type="radio"]:checked[data-variant-id]');
    if (checkedInput && checkedInput.dataset.variantId) {
      return checkedInput.dataset.variantId;
    }

    const selectedVariantScript = document.querySelector('variant-selects [data-selected-variant]');
    if (!selectedVariantScript) return null;

    try {
      const variant = JSON.parse(selectedVariantScript.textContent);
      return variant && variant.id ? String(variant.id) : null;
    } catch (error) {
      return null;
    }
  }

  function updateProductVariantHero(variantId) {
    const heroElement = document.querySelector('[data-product-variant-hero]');
    const descriptionElement = document.querySelector('[data-product-variant-description]');
    const sizeLabelElement = document.querySelector('[data-product-variant-size-label]');
    if (!heroElement && !descriptionElement && !sizeLabelElement) return;

    const resolvedVariantId = variantId ? String(variantId) : getSelectedVariantId();
    const heroMap = getVariantHeroMap();
    if (!heroMap || !resolvedVariantId) return;

    const heroData = heroMap[resolvedVariantId];
    const defaultColor = heroElement
      ? heroElement.dataset.defaultColor || '#f5b2c3'
      : '#f5b2c3';

    if (sizeLabelElement) {
      if (heroData && heroData.size) {
        sizeLabelElement.textContent = heroData.size;
        sizeLabelElement.style.display = '';
        sizeLabelElement.hidden = false;
      } else {
        sizeLabelElement.textContent = '';
        sizeLabelElement.style.display = 'none';
        sizeLabelElement.hidden = true;
      }
    }

    if (heroElement) {
      if (heroData && heroData.text) {
        heroElement.textContent = heroData.text;
        heroElement.style.color = heroData.color || defaultColor;
        heroElement.style.display = '';
        heroElement.hidden = false;
      } else {
        heroElement.textContent = '';
        heroElement.style.display = 'none';
        heroElement.hidden = true;
      }
    }

    if (descriptionElement) {
      if (heroData && heroData.description) {
        descriptionElement.textContent = heroData.description;
        descriptionElement.style.display = '';
        descriptionElement.hidden = false;
      } else {
        descriptionElement.textContent = '';
        descriptionElement.style.display = 'none';
        descriptionElement.hidden = true;
      }
    }
  }

  // Keep size weight labels in sync when the size option changes
  function updateProductWeightRange() {
    const weightRangeElement = document.querySelector('[data-product-weight-range]');
    if (!weightRangeElement) return;

    const variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return;

    const checkedInput = variantSelects.querySelector('input[type="radio"]:checked[data-weight-range]');

    if (checkedInput && checkedInput.dataset.weightRange) {
      weightRangeElement.textContent = checkedInput.dataset.weightRange;
      weightRangeElement.style.display = '';
    } else {
      weightRangeElement.style.display = 'none';
    }
  }

  // Setup variant change listeners
  function setupVariantListeners() {
    const variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return;

    // Listen to click events on labels (which trigger the radio change)
    variantSelects.addEventListener('click', function(event) {
      const label = event.target.closest('label[for]');
      if (label) {
        const inputId = label.getAttribute('for');
        const input = document.getElementById(inputId);
        if (input && input.type === 'radio') {
          // Size/package radios can carry a first-match variant id, which is not
          // the selected combination. Read the selected variant after the click.
          setTimeout(function() {
            updateProductVariantHero();
            if (input.dataset.weightRange) {
              updateProductWeightRange();
            }
          }, 10);
        }
      }
    });

    // Also listen directly to change events on the variant-selects element
    variantSelects.addEventListener('change', function(event) {
      if (event.target && event.target.type === 'radio') {
        setTimeout(function() {
          updateProductVariantHero();
          updateProductWeightRange();
        }, 10);
      }
    });
  }

  // Listen for option value selection changes
  if (typeof subscribe !== 'undefined' && typeof theme !== 'undefined' && theme.PUB_SUB_EVENTS) {
    subscribe(theme.PUB_SUB_EVENTS.optionValueSelectionChange, function(event) {
      setTimeout(function() {
        updateProductVariantHero();
        updateProductWeightRange();
      }, 50);
    });

    // Also listen for variant change events
    subscribe(theme.PUB_SUB_EVENTS.variantChange, function(event) {
      setTimeout(function() {
        const variantId = event && event.data && event.data.variant ? event.data.variant.id : null;
        updateProductVariantHero(variantId);
        updateProductWeightRange();
      }, 50);
    });
  }

  function initSizeFitGuideScrollbars(root) {
    const scope = root || document;
    const scrollAreas = scope.querySelectorAll('[data-size-fit-table-scroll]');

    scrollAreas.forEach(function(scrollEl) {
      if (scrollEl.dataset.sizeFitScrollbarInit === 'true') return;

      const wrap = scrollEl.closest('[data-size-fit-table-wrap]');
      const track = wrap ? wrap.querySelector('[data-size-fit-scrollbar-track]') : null;
      const thumb = wrap ? wrap.querySelector('[data-size-fit-scrollbar-thumb]') : null;

      if (!track || !thumb) return;

      scrollEl.dataset.sizeFitScrollbarInit = 'true';

      function updateScrollbar() {
        if (window.innerWidth >= 750) {
          track.classList.add('is-hidden');
          return;
        }

        const scrollWidth = scrollEl.scrollWidth;
        const clientWidth = scrollEl.clientWidth;
        const maxScroll = scrollWidth - clientWidth;

        if (maxScroll <= 1) {
          track.classList.add('is-hidden');
          return;
        }

        track.classList.remove('is-hidden');

        const trackWidth = track.clientWidth;
        const thumbWidth = Math.max((clientWidth / scrollWidth) * trackWidth, 48);
        const maxThumbLeft = trackWidth - thumbWidth;
        const thumbLeft = maxScroll > 0 ? (scrollEl.scrollLeft / maxScroll) * maxThumbLeft : 0;

        thumb.style.width = thumbWidth + 'px';
        thumb.style.transform = 'translateX(' + thumbLeft + 'px)';
      }

      scrollEl.addEventListener('scroll', updateScrollbar, { passive: true });
      window.addEventListener('resize', updateScrollbar);

      const popup = scrollEl.closest('popup-component');
      const openButton = popup ? popup.querySelector('[data-popup-open]') : null;

      if (openButton) {
        openButton.addEventListener('click', function() {
          requestAnimationFrame(function() {
            setTimeout(updateScrollbar, 50);
            setTimeout(updateScrollbar, 300);
          });
        });
      }

      if (typeof ResizeObserver !== 'undefined') {
        const resizeObserver = new ResizeObserver(updateScrollbar);
        resizeObserver.observe(scrollEl);
        resizeObserver.observe(track);
      }

      updateScrollbar();
    });
  }

  document.addEventListener('shopify:section:load', function(event) {
    initSizeFitGuideScrollbars(event.target);
  });

  // Initial setup
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(reinitializeUpsellSliders, 500);
      setupVariantListeners();
      updateProductVariantHero();
      updateProductWeightRange();
      initSizeFitGuideScrollbars();
    });
  } else {
    setTimeout(reinitializeUpsellSliders, 500);
    setupVariantListeners();
    updateProductVariantHero();
    updateProductWeightRange();
    initSizeFitGuideScrollbars();
  }



  // Free gift promo: auto-add Free Gift Wipes while stock lasts
  (function initFreeGiftPromo() {
    var config = window.themeFreeGift;
    if (!config || !config.enabled || !config.variantId) return;

    var PROPERTY_KEY = config.propertyKey || '_free_gift';
    var syncing = false;
    var lastSyncAt = 0;

    function cartUrl(path) {
      var root = (window.theme && window.theme.routes && window.theme.routes.root) || '/';
      return root.replace(/\/?$/, '/') + path.replace(/^\//, '');
    }

    function fetchCart() {
      return fetch(cartUrl('cart.js'), { credentials: 'same-origin' }).then(function (r) {
        return r.json();
      });
    }

    function isGiftLine(item) {
      if (!item) return false;
      if (String(item.variant_id) === String(config.variantId)) return true;
      if (String(item.product_id) === String(config.productId)) return true;
      if (item.sku === 'Free Gift Wipes x2') return true;
      if (item.properties && String(item.properties[PROPERTY_KEY]) === 'true') return true;
      return false;
    }

    function isClaimGiftLine(item) {
      if (!item || !item.properties) return false;
      return String(item.properties._claim_gift) === 'true';
    }

    function isClaimGiftCart(cart) {
      return (cart.items || []).some(isClaimGiftLine);
    }

    function hasPaidItems(cart) {
      return (cart.items || []).some(function (item) {
        return !isGiftLine(item);
      });
    }

    function findGift(cart) {
      return (cart.items || []).find(isGiftLine) || null;
    }

    function addGift() {
      var payload = {
        id: Number(config.variantId),
        quantity: 1,
        properties: {}
      };
      payload.properties[PROPERTY_KEY] = 'true';
      if (config.label) payload.properties._free_gift_label = config.label;
      // Visible in cart + checkout (keys without "_" are shown)
      if (config.visiblePropertyName && config.visiblePropertyValue) {
        payload.properties[config.visiblePropertyName] = config.visiblePropertyValue;
      }

      return fetch(cartUrl('cart/add.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      }).then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok || data.status) throw data;
          return data;
        });
      });
    }

    function changeLine(key, quantity) {
      return fetch(cartUrl('cart/change.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (r) {
        return r.json();
      });
    }

    function refreshCartUi() {
      document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
    }

    function syncFreeGift(options) {
      options = options || {};
      if (syncing) return Promise.resolve(false);
      if (!config.available && !options.forceRemove) return Promise.resolve(false);

      var now = Date.now();
      if (!options.force && now - lastSyncAt < 400) return Promise.resolve(false);
      lastSyncAt = now;
      syncing = true;

      return fetchCart()
        .then(function (cart) {
          var gift = findGift(cart);
          var paid = hasPaidItems(cart);
          var claimCart = isClaimGiftCart(cart);
          var changed = false;

          // Claim-gift orders already received free wipes with the original gift purchase.
          if (claimCart) {
            if (gift) {
              return changeLine(gift.key, 0).then(function () {
                changed = true;
                return changed;
              });
            }
            return changed;
          }

          if (paid && !gift && config.available) {
            return addGift().then(function () {
              changed = true;
              return changed;
            });
          }

          if (!paid && gift) {
            return changeLine(gift.key, 0).then(function () {
              changed = true;
              return changed;
            });
          }

          if (gift && gift.quantity > 1) {
            return changeLine(gift.key, 1).then(function () {
              changed = true;
              return changed;
            });
          }

          return changed;
        })
        .then(function (changed) {
          syncing = false;
          if (changed && !options.skipRefresh) refreshCartUi();
          return changed;
        })
        .catch(function () {
          syncing = false;
          return false;
        });
    }

    // Expose for gift-checkout redirect path
    window.themeFreeGiftEnsure = function () {
      return syncFreeGift({ skipRefresh: true, force: true });
    };

    document.addEventListener('theme:cart:change', function () {
      setTimeout(function () {
        syncFreeGift();
      }, 250);
    });
    document.addEventListener('theme:product:add', function () {
      setTimeout(function () {
        syncFreeGift();
      }, 350);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        setTimeout(syncFreeGift, 600);
      });
    } else {
      setTimeout(syncFreeGift, 600);
    }
  })();

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
